import { useEffect, useState } from "react";
import { UserWithFullName } from "./constants";
import { UserService } from "services/UserService";

// Custom hook to fetch all user names for a given organization ID
const useAllUserNames = (orgId: string) => {
    const [users, setUserNames] = useState<UserWithFullName[] | null>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!orgId) {
            return;
        }
        let destroyed = false;
        const runFn = async () => {
            const userService = new UserService();

            try {
                setIsLoading(true);
                const res = await userService.getUsersForSharing(orgId);
                if (!destroyed) {
                    const withFullName = res
                        .map((user) => ({
                            ...user,
                            fullName: `${user.firstName} ${user.lastName}`,
                        }))
                        .filter(
                            (user) =>
                                user.email !== "acxmachine@authenticx.com",
                        );
                    setUserNames(withFullName);
                    setIsLoading(false);
                }
            } catch (err) {
                console.error(err);
                setIsLoading(false);
            }
        };
        runFn();
        return () => {
            destroyed = true;
            setUserNames(null);
        };
    }, [orgId]);

    return {
        users,
        isLoading,
    };
};

export default useAllUserNames;
